import $ from "jquery";
import cookie from "js-cookie";

import { MOBILE_BREAK, ROLE_TYPE_MAP, ROLE_TYPE_STRING } from "lib/constants";
import { validateEmail } from "lib/util";

import events from "../events";
import component from "../components";
import util from "../util";

const eventType = "click";
let filters;

let shouldPushState = $(".featured").length;
function goBack(scroll) {
    const useHistory = util.getQueryParam("history");
    if (shouldPushState && !useHistory) {
        window.history.pushState({}, "", "/jobs");
        shouldPushState = false;
    } else {
        window.history.back();
        return;
    }
    closeDetail(scroll);
}

function getAppUrl() {
    return `/app/start/?sn=0&p=${window.p_ids.join(",")}`;
}

function getCopy(count) {
    if (count === 1) {
        return (
            "<strong>1 job chosen</strong> (Select more below)" +
            `<a href="${getAppUrl()}" class="btn btn-primary-reversed">Apply Now</a>`
        );
    }
    if (count === 2) {
        return (
            "<strong>2 jobs chosen</strong> (Select more below)" +
            `<a href="${getAppUrl()}" class="btn btn-primary-reversed">Apply Now</a>`
        );
    }
    if (count === 3) {
        return (
            "<strong>3 jobs selected</strong>" +
            '<button id="apply-now-btn" class="btn btn-primary-reversed">Apply Now</button>'
        );
    }

    return window.job_text;
}

function markInterested(id) {
    const $btn = $(`button[data-id=${id}]`);
    $btn.addClass("inverted");
    $btn.html("&nbsp;INTERESTED");
    $(`#row-${id}`).addClass("selected");
}

function updateSelectedCount() {
    const count = window.p_ids.length;
    $("#job-count").html(getCopy(count));

    if (count === 3) {
        $(".interested-btn:not(.inverted)").addClass("disabled");
        $("#apply-now-btn").click(() => {
            window.location = getAppUrl();
        });
    }
}

let wasInterested = false;
function interestedHandler(e) {
    const el = $(e.currentTarget);
    const id = Number(el.attr("data-id"));

    if (!wasInterested) {
        wasInterested = true;
        $(`#apply-one-${id}`).modal({
            closeClass: "icon-close",
            closeText: "",
            fadeDuration: 350,
            fadeDelay: 0,
        });
        return;
    }
    $.modal.close();

    const index = window.p_ids.indexOf(id);
    const $btn = $(`button[data-id=${id}]`);

    if (el.hasClass("disabled")) {
        return;
    }

    if (el.hasClass("inverted")) {
        $btn.removeClass("inverted");
        $btn.html("I&apos;M INTERESTED");
        $(`#row-${id}`).removeClass("selected");
        $(".interested-btn").removeClass("disabled");
        if (index > -1) {
            window.p_ids.splice(index, 1);
        }
    } else {
        markInterested(id);

        window.p_ids.push(id);

        setTimeout(() => {
            goBack(true);
        }, 500);

        events.track("INTERESTED", "POSITION_INTERESTED");
    }

    cookie.set("selected_positions", window.p_ids.join("|"), { expires: 1 }); // days

    updateSelectedCount();
}

function highlightSelectedPositions() {
    if (!window.p_ids.length) {
        return;
    }

    wasInterested = true;
    window.p_ids.forEach(markInterested);
    updateSelectedCount();
}

function showCommuteEstimateModal(callback) {
    const modal = new component.Filters.CommuteModal({
        el: "#estimate-commute-modal",
    });
    modal.render();
    modal.listenTo(modal, "commute", (commuteData) => {
        if (callback) {
            callback(commuteData);
        }
    });

    if (filters) {
        filters.listenTo(modal, "commute", filters.onCommuteData.bind(filters));
    }
}

function showDetailPage(id, callback) {
    const pid = Number(id.replace(/\D/g, ""));
    const params = [`position_id=${pid}`];

    const $inactive = $(".position-detail-inactive__container");
    if ($inactive.length && $inactive.data("id") === pid) {
        $inactive.fadeIn();
        $(".positions-inner-container").addClass("featured-inactive");
    }

    $.ajax({
        type: "GET",
        url: `/detail?${params.join("&")}`,
        dataType: "html",
        success(content) {
            const $el = $(`#${id}`);
            $el.html(content);
            $el.find(".expanding").each((idx, el) => {
                if (el.scrollHeight > 84) {
                    $(el).children(".expand-btn").show();
                }
            });
            scrollTop();
            $(".footer").show();
            $("#positions-container").addClass("featured");

            if (window.p_ids.indexOf(Number(pid)) > -1) {
                const $btn = $(`button[data-id=${pid}]`);
                $btn.addClass("inverted");
                $btn.html("&nbsp;INTERESTED");
            }

            attachHandlers();

            if (callback) {
                callback();
            }
        },
    });
}

function attachHandlers() {
    $("button.interested-btn").off();
    const count = window.p_ids.length;
    if (count === 3) {
        $(".interested-btn:not(.inverted)").addClass("disabled");
    }
    $("button.interested-btn").click(interestedHandler);

    $(".position-row").off();
    $(".position-row").on(eventType, rowHandler);

    $(".back").off();
    $(".back").on(eventType, () => {
        goBack(false);
    });

    $(".expand-btn").off();
    $(".expand-btn").on(eventType, (e) => {
        const $container = $(e.target).closest(".expanding");
        if ($container.hasClass("open")) {
            $container
                .css({
                    "max-height": "76px",
                    "padding-bottom": "0",
                })
                .removeClass("open");
            $container.find(".expand-btn").html("See more");
        } else {
            $container
                .css({
                    "max-height": "none",
                    "padding-bottom": "26px",
                })
                .addClass("open");
            $container.find(".expand-btn").html("See less");
        }
    });

    const $inactiveBtn = $(".position-inactive__details-button");
    $inactiveBtn.off().on("click", (event) => {
        event.preventDefault();
        event.stopPropagation();

        $inactiveBtn.hide();
        $(".position-details").fadeIn();
    });

    const $inactiveNotify = $(".js-inactive-notify");
    $inactiveNotify.off().on(eventType, (event) => {
        const $parent = $(event.target).closest("[data-id]");
        const positionID = $parent.data("id");

        const $email = $parent.find("input[type=text]");
        const email = $email.val();
        if (!validateEmail(email)) {
            $email.addClass("has-error");

            event.preventDefault();
            event.stopPropagation();
            return;
        }

        const dripTags = [`P${positionID}`];
        const roleType = $parent.data("roleType");
        const role = ROLE_TYPE_STRING[ROLE_TYPE_MAP[roleType]].toLowerCase().split(" ").join("_");
        dripTags.push(`role_${role}`);
        events.trackDrip(
            {
                inactive_jd_subscribe: true,
                email,
                metro: $parent.data("metroShortCode"),
            },
            dripTags,
        );

        $(".position-detail-inactive__cta__copy").fadeOut(() => {
            $(".position-detail-inactive__cta__success").fadeIn();
        });
    });

    const $estimate = $(".js-estimate-commute");
    $estimate.off(eventType).on(eventType, (event) => {
        event.preventDefault();
        event.stopPropagation();

        showCommuteEstimateModal();
    });

    const $detailEstimate = $(".js-estimate-commute-detail");
    $detailEstimate.off(eventType).on(eventType, (event) => {
        event.preventDefault();
        event.stopPropagation();

        const id = `position-detail-${$(event.target).data("id")}`;
        showCommuteEstimateModal(() => {
            showDetailPage(id);
        });
    });

    highlightSelectedPositions();
}

function scrollTop() {
    window.scrollTo(0, 0);
    $("html, body").animate({ scrollTop: 0 }, 50);
}

function closeDetail(scroll, hideFooter) {
    // If you start on a JD page, it will have this class, which will hide all
    // .detail-hidden elements, which includes every item in the job list. So going
    // BACK to the job list and changing any filter will end up with a blank page.
    // Unless you remove this class.
    $("#positions-container").removeClass("featured");

    const $detail = $(".position-detail:visible");
    if ($detail.hasClass("position-inactive")) {
        $(".position-detail-inactive__container").fadeOut();
        $(".positions-inner-container").removeClass("featured-inactive");
    }

    $(".position-detail").hide();
    if (!hideFooter) {
        $(".footer").show();
    }

    $(".detail-hidden").fadeIn();
    if (scroll) {
        scrollTop();
    }
    $("#pagination").fadeIn();
}

function rowHandler(e, callback) {
    $(".detail-hidden").hide();

    const $row = $(e.target).closest(".position-row, .js-job-data");
    const id = $row.data("id");
    const $detail = $(`#${id}`);

    $(".footer").hide();
    $("#pagination").hide();
    $detail.fadeIn();

    window.history.pushState({}, "", $row.data("url"));
    const preload = $row.data("preload");

    // Preload map images on mobile, cuz the lag is jarring
    if (preload && window.innerWidth <= MOBILE_BREAK) {
        const img = new Image();
        img.src = preload;
    }

    events.track("INTERESTED", "POSITION_DETAIL");
    if ($detail.children(".position-map").length) {
        scrollTop();
        return;
    }

    showDetailPage(id, callback);
}

export default function initJobList() {
    window.p_ids = window.p_ids || [];
    window.job_text = $("#job-count").html();
    window.goBack = goBack;
    window.closeDetail = closeDetail;

    let onPopState = [];
    $(window).on("popstate", () => {
        if (window.location.pathname.indexOf("featured") > -1) {
            window.location.reload();
            return;
        }
        closeDetail();

        onPopState.forEach((cb) => {
            cb();
        });
        onPopState = [];
    });

    attachHandlers();

    const $body = $("body");
    $body.on("click", ".js-job-detail", (event) => {
        event.preventDefault();

        const $target = $(event.currentTarget);

        const id = $target.data("id");
        let $container = $("#positions-container");
        const $content = $(".content");

        if (!$container.length) {
            $container = $(
                '<div id="positions-container" class="app-positions-container"><div class="positions-inner-container"></div></div>',
            );
            $content.append($container);
        }
        if (!$(`#${id}`).length) {
            $container
                .find(".positions-inner-container")
                .append(
                    `<div id="${id}" class="position-detail " style="display: none;"><div class="bouncer"></div></div>`,
                );
        }

        const hideFooter = $target.data("hide-footer");
        if (hideFooter) {
            onPopState.push(() => {
                $(".footer").hide();
            });
        }

        rowHandler(event, () => {
            const hideApply = $target.data("hide-apply");
            if (hideApply) {
                $(".interested-btn, .position-aside h3").hide();
            }
        });
    });

    if ($("#filters-container").length) {
        filters = new component.Filters.Component({
            el: "#filters-container",
            // This only exists on role-specific list pages
            hideRoles: !!$(".page-header .heading").length,
            attachHandlers,
        }).render();

        $body.on("click", ".js-clear-filters", (event) => {
            event.preventDefault();

            filters.clear();
        });
    }
}
